import { InvestmentGoalsForeignCurrencies } from '../../../../types';
export var list = [
    InvestmentGoalsForeignCurrencies.ALLOW,
    InvestmentGoalsForeignCurrencies.DENY,
];
